import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Section } from 'components/layout'
import { apiBadges } from 'helpers/decorators/api'
import { get } from 'lodash'
import EngagementBadge from 'components/misc/EngagementBadge/EngagementBadge'
import { FormattedMessage } from 'react-intl'


const enhance = compose(
    apiBadges(
    {
      list: true,
      loadBadgesProgress: true
    }),
    connect(
        ({ api }) => ({
          badgesProgress: api.badges.badgesProgress,
          load: api.badges.loaded,
          loading: api.badges.isLoading
        }),
        {}
    )
)

class BadgesOverview extends Component {
  static propTypes = {
    award: PropTypes.object.isRequired,
    awards: PropTypes.object.isRequired,
    badgesProgress: PropTypes.object.isRequired,
    activity: PropTypes.object.isRequired,
    isBadgesStrictModeEnabled: PropTypes.object.isRequired,
    load: PropTypes.bool,
    loading: PropTypes.bool,
  }

  getActivityBadges = (badges, activitySection) => {
    return badges.filter(i => get(i, 'activitySection.value') === activitySection)
  }

  render() {
    const {
      award,
      awards,
      badgesProgress,
      activity,
      isBadgesStrictModeEnabled,
      loading
    } = this.props

    const awardBadges = get(award, 'badges')

    const activitySection = get(activity, 'activitySection.value')

    const activityBadges = this.getActivityBadges(awardBadges, activitySection)

    const isBadgesEmpty = activityBadges.length === 0

    return (
      <Section loading={loading}>
        <div style={isBadgesEmpty ? { height: '60px' } : {}}>
        {activityBadges && activityBadges.map(
            badge => {
              return (
                <div>
                  {awards.loaded && <EngagementBadge data={badge} awardBadges={awardBadges} badgesProgress={badgesProgress} activity={activity} award={award} isBadgesStrictModeEnabled={isBadgesStrictModeEnabled} />}
                 </div>
                     ) })
        }

        {isBadgesEmpty && <FormattedMessage
            id="badges.no_badges"
            defaultMessage="No badges"
        />}
        </div>
      </Section>
    )
  }
}
export default enhance(BadgesOverview)
